import { createServerFn } from "@tanstack/react-start";

export const loadSiteScriptsServer = createServerFn({ method: "GET" }).handler(async () => {
  const { loadSiteScripts } = await import("./site-scripts.server");

  return loadSiteScripts();
});
